const url = '/supplierAccounts';
const Provider = 'SupplierAccounts';
const dbModel = 'SupplierAccounts';

export { url, Provider, dbModel };
